var map = {
	"./arrow-right.svg": "./src/images/arrow-right.svg",
	"./certificate-seal-light.svg": "./src/images/certificate-seal-light.svg",
	"./chevron-down.svg": "./src/images/chevron-down.svg",
	"./chevron-left.svg": "./src/images/chevron-left.svg",
	"./chevron_right.svg": "./src/images/chevron_right.svg",
	"./chevron_up.svg": "./src/images/chevron_up.svg",
	"./document-pdf.svg": "./src/images/document-pdf.svg",
	"./download.svg": "./src/images/download.svg",
	"./get-support.svg": "./src/images/get-support.svg",
	"./giving-text.svg": "./src/images/giving-text.svg",
	"./kmha-logo-small.svg": "./src/images/kmha-logo-small.svg",
	"./kmu-seal.svg": "./src/images/kmu-seal.svg",
	"./link-external.svg": "./src/images/link-external.svg",
	"./parts-accessories.svg": "./src/images/parts-accessories.svg",
	"./play.svg": "./src/images/play.svg",
	"./plus.svg": "./src/images/plus.svg",
	"./product-manuals.svg": "./src/images/product-manuals.svg",
	"./resource-library.svg": "./src/images/resource-library.svg",
	"./search.svg": "./src/images/search.svg",
	"./world.svg": "./src/images/world.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images sync recursive \\.(gif|png|jpe?g|svg)$";